export function facebooklogin(req) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req)
    };
    console.log('POST Login **************', JSON.stringify(requestOptions))
    return fetch('/shared/api/auth/facebook', requestOptions).then((response) => response.json())
}